import { ComponentBlock } from '@src/constants/componentBlock'
import { useComponentBlockerContext } from '@src/contexts/share/ComponentBlockerContext'
import * as R from 'ramda'
import { FC, ReactNode } from 'react'

const ComponentBlocker: FC<Props> = props => {
  const { blockKey, children } = props

  const { blockKeys } = useComponentBlockerContext()

  const allow = !R.includes(blockKey, blockKeys)

  return <>{allow && children}</>
}

type Props = {
  blockKey: ComponentBlock
  children?: ReactNode
}

export default ComponentBlocker
